const stepper = ["対象施設一覧/対象外施設への異動情報", "機構へ提出"];
const KikotableHeadList: any[] = [
  {
    headTitle: "氏名",
    width: "25%",
  },
  {
    headTitle: "配置換え前施設名",
    width: "10%",
  },
  {
    headTitle: "配置換え後施設名",
    width: "10%",
  },
  {
    headTitle: "配置換え年月日",
    width: "10%",
  },
  {
    headTitle: "処理状況",
    width: "10%",
  },
  {
    headTitle: "異動・復帰登録",
    width: "10%",
  },
];
export { stepper, KikotableHeadList };
